import './App.css';
import { Routes, Route } from 'react-router-dom';
import Shell from './components/layout/Shell';
import MainPortfolioPage from './pages/MainPortfolioPage';
import YogeshSinghPage from './pages/YogeshSinghPage';

function App() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<MainPortfolioPage />} />
        <Route path="/yogesh-singh" element={<YogeshSinghPage />} />
      </Route>
    </Routes>
  );
}

export default App;
